<template>
  <div v-if="historyItems.length > 0">
    <v-divider class="my-4" />
    <title-model-a icon="history" title="Últimas 10 consultas en caché" />

    <v-list dense>
      <v-list-item
        v-for="(item, index) in historyItems"
        :key="index"
        class="mt-2 cb-row-bordered"
        dense
        two-line
      >
        <v-list-item-content>
          <v-list-item-title>
            {{ item.domain_id == null ? "(Domnio)" : "(Subcuenta)" }} {{ item.date | moment("DD MM YYYY") }}
            ({{ item.date | moment("from") }})
          </v-list-item-title>
          <v-list-item-subtitle>
            <span class="text-uppercase">
              {{ getDomainNames(item.result) }}
            </span>
          </v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-action>
          <v-row>
            <v-btn icon @click="$emit('view', index)">
              <v-icon color="primary">visibility</v-icon>
            </v-btn>
            <v-btn icon @click="$emit('delete', index)">
              <v-icon color="error">delete</v-icon>
            </v-btn>
          </v-row>
        </v-list-item-action>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
import TitleModelA from "@/components/repository/TitleModelA.vue";

export default {
  name: "DomainHistoryList",
  components: {
    TitleModelA
  },
  props: {
    historyItems: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    getDomainNames(result) {
      return result.map(d => d.name).join(", ");
    }
  }
};
</script>
